module.exports = __webpack_public_path__ + "static/media/non_member_favorite_01.91b0ff6f.jpg";